module.exports = __webpack_public_path__ + "static/electriciansFooterPin-9d629e11c480950434e2dbdc136854e0.png";